import { PRICING_API_URL } from "../../../env";
import { ChainIds, ChainNamespaces } from "../../consts";
import { DEFAULT_ETHERS_DECIMALS } from "../utils";

const commonConfig = {
  namespace: ChainNamespaces.EVM,
  symbol: "ETH",
  buyTezUrl: "",
  tzktApiUrl: "",
  chain: ChainIds.ETHEREUM,
  decimals: DEFAULT_ETHERS_DECIMALS,
};

export const ethereumConfig = {
  // Mainnet
  // Infura seems to be the more private reliable provider for mainnet (you would need to register to infura and get an api key)
  mainnet_infura: {
    name: "Ethereum",
    rpcUrl: `${PRICING_API_URL}/infura/mainnet`,
    identifier: "1",
    explorerUrl: "https://eth.blockscout.com",
    explorerProxyUrl: `${PRICING_API_URL}/blockscout/mainnet`,
    ...commonConfig,
  },
  mainnet_blockscout: {
    name: "Ethereum",
    rpcUrl: "https://eth.blockscout.com/api/eth-rpc",
    identifier: "1",
    explorerUrl: "https://eth.blockscout.com",
    explorerProxyUrl: `${PRICING_API_URL}/blockscout/mainnet`,
    ...commonConfig,
  },
  // Testnet
  // Infura seems to be the more private reliable provider for sepolia (you would need to register to infura and get an api key)
  testnet_infura_sepolia: {
    name: "Ethereum Sepolia",
    rpcUrl: `${PRICING_API_URL}/infura/sepolia`,
    identifier: "11155111",
    explorerUrl: "https://eth-sepolia.blockscout.com",
    explorerProxyUrl: `${PRICING_API_URL}/blockscout/sepolia`,
    isTestnet: true,
    ...commonConfig,
  },
  // Onfinality seems to be the more public reliable provider for sepolia
  testnet_onfinality_sepolia: {
    name: "Ethereum Sepolia",
    identifier: "11155111",
    rpcUrl: "https://eth-sepolia.api.onfinality.io/public",
    explorerUrl: "https://eth-sepolia.blockscout.com",
    explorerProxyUrl: `${PRICING_API_URL}/blockscout/sepolia`,
    isTestnet: true,
    ...commonConfig,
  },
  testnet_blockscout_sepolia: {
    name: "Ethereum Sepolia",
    identifier: "11155111",
    rpcUrl: "https://eth-sepolia.blockscout.com/api/eth-rpc",
    explorerUrl: "https://eth-sepolia.blockscout.com",
    explorerProxyUrl: `${PRICING_API_URL}/blockscout/sepolia`,
    isTestnet: true,
    ...commonConfig,
  },
  testnet_blockscout_holesky: {
    name: "Ethereum Holesky",
    identifier: "17000",
    rpcUrl: "https://ethereum-holesky-rpc.publicnode.com",
    explorerUrl: "https://eth-holesky.blockscout.com",
    explorerProxyUrl: `${PRICING_API_URL}/blockscout/holesky`,
    isTestnet: true,
    ...commonConfig,
  },
} as const;
